module.exports = __webpack_public_path__ + "static/kvitova-gray-baf4b1bb8b5c93c6fd03d4500b929d3f.png";